import React from "react";

const FlexSpacer = () => <div className={`flex-spacer`} />;

export default FlexSpacer;
